// extracted by mini-css-extract-plugin
export default {"FooterStyle":"Footer_FooterStyle__l-kVr","footer":"Footer_footer__pebVX","line":"Footer_line__Ese-L","copyright":"Footer_copyright__3E1Pz"};